import { Flex, Icon, Text } from '@chakra-ui/react';
import DescriptionField from './Description';
import { No, StrongNo, StrongYes, Yes } from '@/assets/icons/scorecard';

const options = [
  { id: 'strongYes', label: 'Strong yes', icon: StrongYes },
  { id: 'yes', label: 'Yes', icon: Yes },
  { id: 'no', label: 'No', icon: No },
  {
    id: 'strongNo',
    label: 'Strong no',
    icon: StrongNo,
  },
];

export const OverallEvaluation = () => {
  return (
    <Flex
      border="1px solid"
      borderColor="border-color"
      p="20px"
      borderRadius="sm"
      flexDir="column"
      gap="10px"
    >
      <Text size="sm-medium">Overall evaluation</Text>
      <DescriptionField name="rating_description" />
      {options?.map((item) => (
        <Flex key={item?.id} alignItems="center" gap="6px">
          <Icon
            className="primary-900"
            as={item?.icon}
            width="18px"
            height="18px"
            {...item?.iconProps}
            data-test-id={`option-rating-${item?.id}`}
          />
          <Text fontSize="sm">{item?.label}</Text>
        </Flex>
      ))}
    </Flex>
  );
};
